'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarClock, iconCalendarClockTag } from '@ni/nimble-components/dist/esm/icons/calendar-clock';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarClock };
export { iconCalendarClockTag };
export const NimbleIconCalendarClock = wrap(IconCalendarClock);